import React from "react";

function PollIcon() {
  return (
    <span className="anticon anticon-poll">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 17 16"
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="currentColor"
          strokeLinecap="square"
          strokeWidth="1.5"
          d="M1.572 15.083h14.667m-12.834 0V5h3.667v10.083m0 0V1.333h3.667v13.75m0 0V7.75h3.666v7.333"
        ></path>
      </svg>
    </span>
  );
}

export default PollIcon;
